var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-box",
      class: [
        "field-box--" + _vm.type.toLowerCase(),
        { selected: _vm.selected }
      ],
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.closable && _vm.selected
        ? _c(
            "button",
            {
              staticClass: "field-box__close",
              attrs: { type: "button", title: "Eliminar campo" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("close")
                },
                mousedown: function($event) {
                  $event.stopPropagation()
                },
                touchstart: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v(" × ")]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "field-box__body", style: _vm.bodyStyle },
        [
          _vm.isCheckbox
            ? _c(
                "span",
                {
                  staticClass: "field-box__checkmark",
                  style: { fontSize: _vm.checkboxSize + "px" }
                },
                [_vm._v("☐")]
              )
            : [
                _c("span", { staticClass: "field-box__label" }, [
                  _vm._v(" " + _vm._s(_vm.label)),
                  _vm.required
                    ? _c("span", { staticClass: "field-box__req" }, [
                        _vm._v("*")
                      ])
                    : _vm._e()
                ]),
                _c("span", { staticClass: "field-box__sample" }, [
                  _vm._v(_vm._s(_vm.sample))
                ])
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }